import React from "react";
import styled from "@emotion/styled";
import getStripe from "../stripe";
import { RootState } from "../redux/root-store";
import { connect } from "react-redux";
import HeaderLayout from "../components/header-layout";

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    margin-top: 1rem;

    .cancel-plan {
        width: 100%;
        text-align: center;
        display: block;
    }
`;

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface Props extends ReturnType<typeof mapStateToProps> {}

const planTable = `
            <stripe-pricing-table
                pricing-table-id="prctbl_1LdckPJzggypaXug6rhqP2gu"
                publishable-key="pk_live_51Kvn3MJzggypaXugIDi3eRItJ3WHiFceS6XHsM5ottaPlgBv7Jg1BFgjbq84WS3eEc0KNeVLr8iwruymCpIy1kS300sDUzUt9U"
            ></stripe-pricing-table>
`;

const testPlanTable = (userId: string) => `
<stripe-pricing-table pricing-table-id="prctbl_1MmbysJzggypaXugIs0lQGik"
client-reference-id="${userId}"
publishable-key="pk_test_51Kvn3MJzggypaXug4RqIR7EoNLUj6qCSKL5OCpyPnDOokNRzgQvdFcOthq4K7eBWjiHwIf7Q5WXZo8uDZXwJsisF005QZtTbMG">
</stripe-pricing-table>
`;

const Purchase = (props: Props) => {
    const { loggedUser } = props;

    if (!loggedUser) return null;

    return (
        <HeaderLayout>
            <Container
                dangerouslySetInnerHTML={{
                    __html: `${planTable} <span class="cancel-plan" >Need to downgrade or cancel, please <a href="mailto:support@networknerd.app">contact us</a>.</span>`,
                }}
            />
        </HeaderLayout>
    );
};

export default connect(mapStateToProps, {})(Purchase);
